import script from "./OtherCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherCard.vue?vue&type=script&setup=true&lang=js"

import "./OtherCard.vue?vue&type=style&index=0&id=0c809732&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c809732"]])

export default __exports__